
import React from 'react';
import { logger } from 'services/logger';
import VuiBox from 'components/VuiBox';
import VuiTypography from 'components/VuiTypography';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    // Atualiza o estado para que a próxima renderização mostre a UI de fallback.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Você também pode registrar o erro em um serviço de relatórios de erro
    logger.error("ErrorBoundary pegou um erro:", { 
      error: error.toString(), 
      errorInfo: errorInfo.componentStack 
    });
    this.setState({ error, errorInfo });
  }

  render() {
    if (this.state.hasError) {
      // Você pode renderizar qualquer UI de fallback personalizada
      return (
        <VuiBox display="flex" justifyContent="center" alignItems="center" height="100vh">
          <VuiTypography color="white" variant="h4">
            Algo deu errado na aplicação.
          </VuiTypography>
          {/* Opcional: mostrar detalhes do erro em desenvolvimento */}
          {process.env.NODE_ENV === 'development' && this.state.error && (
            <pre style={{ color: 'red', marginTop: '20px', whiteSpace: 'pre-wrap' }}>
              {this.state.error.toString()}
              <br />
              {this.state.errorInfo?.componentStack}
            </pre>
          )}
        </VuiBox>
      );
    }

    return this.props.children; 
  }
}

export default ErrorBoundary;
